import seeds from './index.yaml'

export function getSeedsFor(type) {
  const seed = (new URLSearchParams(window.location.search)).get('seed')

  if (!seed) {
    return []
  }

  return seeds.filter(x => x.type === type && x.id === seed).map(x => x.data)
}